<script>
import {mapGetters} from "vuex";

export default {
  name: "EmailModule",
  props : {
    emailInfo : {
      type : Object,
      default : null
    }
  },
  data() {
    return {
      is_included : 0,
      is_to : 0,
      is_cc : 0
    }
  },
  computed: {
    ...mapGetters('ModuleTableModule', [
      'moduleKeys'
    ]),
    features() {
      return this.moduleKeys.filter(module => module.code === this.emailInfo.code)[0]?.features ?? []
    }
  }
}
</script>

<template>
  <div class="card shadow-sm p-3">
    <div class="row">
      <div class="p-3 col-4" v-for="feature in features">
        <div class="card p-2">
          <h6 class="font-weight-bold">{{ feature.name }}</h6>

          <div class="row align-items-center no-gutters">
            <div class="col-lg-9 p-0">
              <div class="form-check">
                <input class="form-check-input checkbox-input" type="checkbox" :id="feature.id" v-model="is_included">
                <label :for="feature.id" class="module_label font-weight-bold col-form-label no-select cursor-pointer"> Included </label>
              </div>
            </div>
          </div>
          <div class="row align-items-center no-gutters ml-2">
            <div class="col-lg-9 p-0">

              <div class="form-check form-check-inline mr-3">
                <input
                  class="form-check-input checkbox-input"
                  type="radio"
                  name="recipient_type"
                  id="to"
                  value="TO"
                  v-model="recipientType"
                >
                <label
                  class="form-check-label module_label font-weight-bold no-select cursor-pointer"
                  for="to"
                >
                  TO
                </label>
              </div>

              <div class="form-check form-check-inline">
                <input
                  class="form-check-input checkbox-input"
                  type="radio"
                  name="recipient_type"
                  id="cc"
                  value="CC"
                  v-model="recipientType"
                >
                <label
                  class="form-check-label module_label font-weight-bold no-select cursor-pointer"
                  for="cc"
                >
                  CC
                </label>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
